import { Hero } from '../components/sections/Hero';
import { Mission } from '../components/sections/Mission';
import { WhyUs } from '../components/sections/WhyUs';
import { TrainingCards } from '../components/sections/TrainingCards';
import { Instructors } from '../components/sections/Instructors';
import { Testimonials } from '../components/sections/Testimonials';
import { SplitBlock } from '../components/sections/SplitBlock';
import { Contact } from '../components/sections/Contact';
import { SEO } from '../components/SEO';

export const Home = () => {
  return (
    <main data-testid="home-page">
      <SEO
        description="Gyakorlati készségfejlesztés több mint 20 év tapasztalattal. Ingatlanközvetítői képzés, céges tréningek, workshopok. Budapest, 1027 Kapás utca 6-12."
        path="/"
      />
      <Hero />
      <Mission />
      <div className="relative section-transition-down" style={{ '--next-bg': '#07516B' }}>
        <WhyUs />
      </div>
      <div className="relative section-transition-down" style={{ '--next-bg': '#07516B' }}>
        <TrainingCards />
      </div>
      <Instructors />
      <div className="relative section-transition-down" style={{ '--next-bg': '#404041' }}>
        <Testimonials />
      </div>
      <div className="relative section-transition-down" style={{ '--next-bg': '#07516B' }}>
        <SplitBlock />
      </div>
      <Contact />
    </main>
  );
};

export default Home;
